import React from "react";
import { Stack, Paper, Group, Text, ActionIcon } from "@mantine/core";
import {
  IconListDetails,
  IconListSearch,
  IconChevronRight,
} from "@tabler/icons-react";

const COLOR_BORDER_LIGHT = "#e9ecef";
const COLOR_BACKGROUND_WHITE = "#FFFFFF";
const COLOR_BACKGROUND_LIGHT = "#f8f9fa";

interface WebsiteGeneratorContentOptionsProps {
  onRequiredSectionsClick: () => void;
  onOptionalSectionsClick: () => void;
  hasRequiredSectionsError?: boolean;
  hasOptionalSectionsError?: boolean;
}

const WebsiteGeneratorContentOptions: React.FC<
  WebsiteGeneratorContentOptionsProps
> = ({
  onRequiredSectionsClick,
  onOptionalSectionsClick,
  hasRequiredSectionsError = false,
  hasOptionalSectionsError = false,
}) => {
  const contentOptions = [
    {
      title: "Required Sections",
      subtitle: "Edit essential website content",
      icon: <IconListDetails size={20} />,
      onClick: onRequiredSectionsClick,
      hasError: hasRequiredSectionsError,
    },
    {
      title: "Optional Sections",
      subtitle: "Add more content to your website",
      icon: <IconListSearch size={20} />,
      onClick: onOptionalSectionsClick,
      hasError: hasOptionalSectionsError,
    },
  ];

  return (
    <Stack gap="sm">
      {contentOptions.map((option, index) => {
        const borderColor = option.hasError ? "red" : COLOR_BORDER_LIGHT;
        return (
          <Paper
            key={index}
            p="md"
            style={{
              border: `1px solid ${borderColor}`,
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onClick={option.onClick}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = COLOR_BACKGROUND_LIGHT;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = COLOR_BACKGROUND_WHITE;
            }}
          >
            <Group justify="space-between" align="center">
              <Group gap="sm">
                <ActionIcon variant="light" color="gray" size="lg" radius="md">
                  {option.icon}
                </ActionIcon>
                <Stack gap={0}>
                  <Text
                    fw={500}
                    size="sm"
                    c={option.hasError ? "red" : undefined}
                  >
                    {option.title}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {option.subtitle}
                  </Text>
                </Stack>
              </Group>
              <ActionIcon variant="subtle" color="gray">
                <IconChevronRight size={16} />
              </ActionIcon>
            </Group>
          </Paper>
        );
      })}
    </Stack>
  );
};

export default WebsiteGeneratorContentOptions;
